import React  from "react";

const ChangeBankDetailsInLine={
  BankTitle: "Bank account",
  OpertaionInsert:"I",
  OpertaionUpdate:"U",
  OpertionDelete:"D",
  AccountNoTitle:"Account number",
  AccountNameTitle:"Account holder name",
  SortCodeTitle:"Sort code",
  AccNo:"AccountNumber",
  AccName:"AccountHolderName",
  SortCode:"SortCode",
    ValidationErrors: {
      NoChanges:"You have made no changes to the existing data",
        EmptySortCode:
          "Please enter sort code",
          EmptyAccountNo:
          "Please enter account number",
          EmptyAccountName:
          "Please enter account holder name",

          InvalidSortCode:
          "Please enter a valid sort code. It must be numeric with six digits",
          InvalidAccountNo:
          "Please enter a valid account number. It must be numeric with eight digits",
          InvalidAccountName:
          "Please enter a valid account holder name",
          InvalidAccName:
          "Please enter a valid account holder name. It must be alphabets with ' and - and cannot exceed 34 chars",

        
        GenericError: "Sorry, there was a problem updating your bank account."
      },
    DeleteConfirmTooltip:
    (<>
    Are you sure you want to delete these account details? If we dont 
    <br></br>  hold details for you, we'll send you a cheque
    </>
    ),
    CrestupdateNotification:
    (<>
      You can add bank details 24 hours after your account has been created. 
      <br></br>Bank details can be updated only once every 24 hours.
      </>
      )

  };

export default ChangeBankDetailsInLine;





